import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registrationStepName: null,
};

const registrationStepSlice = createSlice({
  name: "registrationStep",
  initialState,
  reducers: {
    setRegistrationStepName(state, action) {
      state.registrationStepName = action.payload;
    },
    clearRegistrationStepName(state) {
      state.registrationStepName = null;
    },
  },
});

export const { setRegistrationStepName, clearRegistrationStepName } =
  registrationStepSlice.actions;
export default registrationStepSlice;
